import React from "react";
import {
  SkeletonBar,
  SkeletonPill,
  SkeletonCardBox,
  SkeletonRow,
  SkeletonHRow,
} from "./StoryBuilder.skeleton.styles";

export const GoalSkeleton: React.FC = () => (
  <SkeletonRow>
    <SkeletonBar $w="70%" />
    <SkeletonBar $w="50%" />
  </SkeletonRow>
);

export const PurposeSkeleton: React.FC = () => (
  <SkeletonRow>
    <SkeletonBar $w="100%" />
    <SkeletonBar $w="95%" />
    <SkeletonBar $w="80%" />
    <SkeletonBar $w="50%" />
  </SkeletonRow>
);

export const AudienceSkeleton: React.FC = () => (
  <SkeletonHRow>
    <SkeletonPill $w="120px" $h={28} />
    <SkeletonPill $w="110px" $h={28} />
    <SkeletonPill $w="130px" $h={28} />
  </SkeletonHRow>
);

export const FormatSkeleton: React.FC = () => (
  <SkeletonHRow style={{ flexWrap: "wrap" }}>
    {[0, 1, 2, 3, 4].map((i) => (
      <SkeletonCardBox key={i} $h={60} style={{ minWidth: 80 }} />
    ))}
  </SkeletonHRow>
);

export const LayoutSkeleton: React.FC = () => (
  <SkeletonHRow style={{ flexWrap: "wrap" }}>
    {[0, 1, 2, 3, 4].map((i) => (
      <SkeletonCardBox key={i} $h={94} style={{ minWidth: 100 }} />
    ))}
  </SkeletonHRow>
);

export const SourcesSkeleton: React.FC = () => (
  <SkeletonRow>
    <SkeletonBar $h={40} />
    <SkeletonBar $h={40} />
  </SkeletonRow>
);

export const KeyAreasSkeleton: React.FC = () => (
  <SkeletonRow>
    <SkeletonBar $w="90%" />
    <SkeletonBar $w="85%" />
    <SkeletonBar $w="70%" />
  </SkeletonRow>
);

export const ClarificationSkeleton: React.FC = () => (
  <SkeletonRow>
    <SkeletonBar $w="75%" />
    <SkeletonBar $w="70%" />
    <SkeletonBar $w="65%" />
    <SkeletonBar $w="55%" />
  </SkeletonRow>
);
